export * from './core';
export * from './ui-bootstrap';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/index.js
// module id = 184
// module chunks = 3